module.exports = __webpack_public_path__ + "static/media/logo.ed64575b.png";